<template lang='pug'>
v-dialog(
  :value='dialog'
  fullscreen
)
  v-card
    v-toolbar(
      dark
      flat
      tile
    )
      v-btn.mx-2(
        icon
        @click='dialog = !dialog'
      )
        v-icon mdi-close
      v-spacer
      v-btn.mx-2(
        v-if='loading'
        icon
        outlined
        :loading='loading'
      )
    v-container
      slot(
        :start='() => loadingUpdate(true)'
        :stop='() => loadingUpdate(false)'
      )
</template>

<script>
import { useEventToProp } from '../functions/useEventToProp';

const setup = () =>
{
  const { prop: loading, propUpdate: loadingUpdate } = useEventToProp();

  return {
    loading,
    loadingUpdate,
  };
};

function mounted()
{
  this.dialog = true;
}

export default
{
  data()
  {
    return {
      dialog: false
    };
  },
  mounted,
  setup,
};
</script>